<section class="fullWidthCls admManageExam marginAtTop">
  <div class="container-fluid">
    <div class="row">
      <div class="admManageExamPageTitle">
        <p class="admManageExamPageTitleSec">
          <img src="./assets/images/manageExamTitleIcon.png" alt="" />
          <span>Exam Deliveries</span>
        </p>
      </div>
      <!-- Add Edit form -->
      <div class="admManageExamBreadcumTitle">
        <p class="admManageExamBreadcumCls">
          <span>
            <a class="searchFormLink" [showUnSavedChangesAlert]="{ form: form, redirect: 'AdmManageEligibilities'}">Exam Deliveries</a> >
            <span class="addEditFormLink">Manage Error Case</span>
          </span>
        </p>
      </div>
      <md-card>
        <md-card-header>
          <div class="admManageExamSec">
            <md-card-title>
              <div class="admManageExamSecTitle">
                <p>
                  <span>Error Case Details</span>
                </p>
              </div>
            </md-card-title>
          </div>
        </md-card-header>
        <md-card-content>
          <form class="example-form" novalidate [formGroup]="form">
            <div class="col s12 m4 l4">
              <md-form-field class="example-full-width">
                <input mdInput placeholder="Candidate Name" formControlName="candidateName">
              </md-form-field>
            </div>
            <div class="col s12 m4 l4">
              <md-form-field class="example-full-width">
                <input mdInput placeholder="Location name" formControlName="locationName">
              </md-form-field>
            </div>
            <div class="col s12 m4 l4">
              <md-form-field class="example-full-width">
                <input mdInput placeholder="Exam Code: Name" formControlName="examCodeName">
              </md-form-field>
            </div>
            <div class="col s12 m4 l4">
              <md-form-field class="example-full-width">
                <input mdInput placeholder="Current Status" formControlName="statusDisplay">
              </md-form-field>
            </div>
            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-select placeholder="Resolve by" formControlName="changeStatusTo">
                  <md-option *ngFor="let option of changeStatusto" [value]="option[0]">
                    {{ option[1] }}
                  </md-option>
                </md-select>
                <p requiredField *ngIf="form.controls.changeStatusTo.touched && form.controls.changeStatusTo.invalid"></p>
              </div>
            </div>
          </form>
        </md-card-content>
      </md-card>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-eligibilities/adm-manage-error-case/adm-manage-error-case.component.html